/**
 * HubSpot Integration Enums
 *
 * Enums used across the HubSpot integration entities
 */

/**
 * Setup Status Enum
 * Tracks the progress of the HubSpot integration wizard setup
 */
export enum HubSpotSetupStatus {
  CONNECTED = "CONNECTED",
  USERS_CONFIGURED = "USERS_CONFIGURED",
  COMPANIES_CONFIGURED = "COMPANIES_CONFIGURED",
  CONTACTS_CONFIGURED = "CONTACTS_CONFIGURED",
  FIELDS_MAPPED = "FIELDS_MAPPED",
  COMPLETED = "COMPLETED",
}

/**
 * HubSpot sync job type (Ampersand push model).
 * Aligned with Salesforce SyncJobType for consistency; source (backfill/scheduled/live) goes in metadata.
 */
export enum HubSpotSyncJobType {
  USER_SYNC = "USER_SYNC",
  ACCOUNT_SYNC = "ACCOUNT_SYNC",
  CONTACT_SYNC = "CONTACT_SYNC",
  /** Applying a company filter sweep's cleanup (SKR-948). Not an Ampersand read. */
  COMPANY_FILTER_CLEANUP = "COMPANY_FILTER_CLEANUP",
  /** Applying a contact filter sweep's cleanup (SKR-955). Not an Ampersand read. */
  CONTACT_FILTER_CLEANUP = "CONTACT_FILTER_CLEANUP",
}

/** HubSpot object a filter sweep reads and cleans up (SKR-955). */
export type HubSpotFilterObject = "companies" | "contacts";

/**
 * HubSpot sync log status.
 * Aligned with Salesforce SyncStatus (includes COMPLETED_WITH_ERRORS).
 */
export enum HubSpotSyncLogStatus {
  STARTED = "STARTED",
  COMPLETED = "COMPLETED",
  COMPLETED_WITH_ERRORS = "COMPLETED_WITH_ERRORS",
  FAILED = "FAILED",
  SKIPPED = "SKIPPED",
}

/**
 * Lifecycle of a HubSpot company-filter sweep (full read + preview + apply).
 */
export enum HubSpotCompanyFilterSweepStatus {
  READING = "READING", // full read triggered, not settled yet
  READY = "READY", // read settled; preview available; can apply
  APPLYING = "APPLYING",
  APPLIED = "APPLIED",
  FAILED = "FAILED",
  SUPERSEDED = "SUPERSEDED", // a newer filter change replaced it
}
